export const COMPLETE_PROFILE_T = {
  fr: {
    tagline: "Tous les outils dont vous avez besoin.\nUne seule plateforme.",
    title: 'Complétez votre profil',
    reason: 'Nous avons besoin de votre numéro de téléphone pour vous contacter au sujet de votre boutique et de vos commandes.',
    phoneLabel: 'Numéro de téléphone',
    phonePlaceholder: '555 12 34 56',
    save: 'Enregistrer',
    logout: 'Se déconnecter',
    errorInvalid: "Ce numéro de téléphone n'est pas valide. Vérifiez-le et réessayez.",
    errorTaken: 'Ce numéro est déjà utilisé par un autre compte.',
    errorSms: "Le SMS n'a pas pu être envoyé, réessayez.",
    errorGeneric: "Impossible d'enregistrer votre numéro. Vérifiez votre connexion et réessayez.",
    codeTitle: 'Confirmez votre numéro',
    codeDesc: 'Un code à 6 chiffres a été envoyé au',
    codeLabel: 'Code de vérification',
    codePlaceholder: '000000',
    verify: 'Vérifier',
    verifyLater: 'Vérifier plus tard',
    codeEmpty: 'Veuillez saisir le code de vérification.',
    codeIncorrect: 'Code incorrect. Vérifiez le SMS et réessayez.',
    verifyFailed: 'Impossible de vérifier le code. Réessayez ou vérifiez plus tard.',
  },
  en: {
    tagline: 'Every tool you need.\nOne platform.',
    title: 'Complete your profile',
    reason: 'We need your phone number to contact you about your store and orders.',
    phoneLabel: 'Phone number',
    phonePlaceholder: '555 12 34 56',
    save: 'Save',
    logout: 'Log out',
    errorInvalid: 'This phone number is not valid. Check it and try again.',
    errorTaken: 'This phone number is already used by another account.',
    errorSms: 'The SMS could not be sent, please try again.',
    errorGeneric: 'Could not save your number. Check your connection and try again.',
    codeTitle: 'Confirm your phone number',
    codeDesc: 'A 6-digit code was sent to',
    codeLabel: 'Verification code',
    codePlaceholder: '000000',
    verify: 'Verify',
    verifyLater: 'Verify later',
    codeEmpty: 'Please enter the verification code.',
    codeIncorrect: 'Incorrect code. Check the SMS and try again.',
    verifyFailed: 'Could not verify the code. Try again or verify later.',
  },
  ar: {
    tagline: 'كل الأدوات التي تحتاجها.\nمنصة واحدة.',
    title: 'أكمل ملفك الشخصي',
    reason: 'نحتاج إلى رقم هاتفك للتواصل معك بشأن متجرك وطلباتك.',
    phoneLabel: 'رقم الهاتف',
    phonePlaceholder: '555 12 34 56',
    save: 'حفظ',
    logout: 'تسجيل الخروج',
    errorInvalid: 'رقم الهاتف هذا غير صالح. تحقق منه وأعد المحاولة.',
    errorTaken: 'رقم الهاتف هذا مستخدم بالفعل في حساب آخر.',
    errorSms: 'تعذر إرسال الرسالة القصيرة، أعد المحاولة.',
    errorGeneric: 'تعذر حفظ رقمك. تحقق من اتصالك وأعد المحاولة.',
    codeTitle: 'تأكيد رقم الهاتف',
    codeDesc: 'تم إرسال رمز مكون من 6 أرقام إلى',
    codeLabel: 'رمز التحقق',
    codePlaceholder: '000000',
    verify: 'تحقق',
    verifyLater: 'التحقق لاحقًا',
    codeEmpty: 'يرجى إدخال رمز التحقق.',
    codeIncorrect: 'الرمز غير صحيح. تحقق من الرسالة وأعد المحاولة.',
    verifyFailed: 'تعذر التحقق من الرمز. أعد المحاولة أو تحقق لاحقًا.',
  },
};
